module.exports = __webpack_public_path__ + "static/media/9DESA33.d42af4ab.jpg";